import { fetchConToken } from '../helpers/fetch';

const ArchivosMigracionService = {
    getArchivos : (fechaDesde, fechaHasta, tipoArchivo) => {
        return fetchConToken(`ArchivosMigracion?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}&tipoArchivo=${tipoArchivo}`)
    },
    getNovedades : () => {
        return fetchConToken(`ArchivosMigracion/novedades`)
    },
    postBajasNovedades : (jsonData) => {
        return fetchConToken(`ArchivosMigracion/realizarBajaNovedades`, {jsonData}, "POST")
    },
    getParametrosImportacion:()=>{
        return fetchConToken(`ParametrosImportacion`)
    }
}

export {ArchivosMigracionService as default}